export default __webpack_public_path__ + "6876f78f9843a753f4e5679df9eb9180.png";